import { Injectable } from '@angular/core';
import { interval, Observable, of } from 'rxjs';
import { catchError, delay, startWith, switchMap } from 'rxjs/operators';
import { WfmApiService } from 'app/wfm/shared/services/wfm-api.service';
import { UserService } from '@shared/core';
import { ScheduleData } from 'app/wfm/shared/models/types';
import { CalendarService } from 'app/wfm/shared/services/wfm-calendar.service';
import { WfmOperatorScheduleReminderService } from './wfm-operator-schedule-reminder.service';

const POLLING_DELAY_MS = 2500;
const POLLING_INTERVAL_MS = 2 * 60 * 1000;
const REQUIRED_ROLE = 'ROLE_WFM_GET_OPERATOR_SCHEDULE';

@Injectable({
  providedIn: 'root',
})
export class WfmOperatorPollingService {
  constructor(
    private readonly currentUser: UserService,
    private readonly calendarService: CalendarService,
    private readonly scheduleReminder: WfmOperatorScheduleReminderService,
    private readonly api: WfmApiService,
  ) {}

  init(): void {
    this.startPolling().subscribe(schedule => {
      this.scheduleReminder.process(schedule);
    });
  }

  private startPolling(): Observable<ScheduleData> {
    return interval(POLLING_INTERVAL_MS).pipe(
      startWith(0),
      delay(POLLING_DELAY_MS),
      switchMap(() => this.getSchedule()),
    );
  }

  private getSchedule(): Observable<ScheduleData> {
    if (!this.currentUser.hasRole(REQUIRED_ROLE)) {
      return of();
    }

    const dayInterval = this.calendarService.getDayInterval(new Date());
    const userId = this.currentUser.getUser().id;
    return this.api.getSchedule(userId, dayInterval).pipe(catchError(of));
  }
}
